'use client';

import { NavigationLogo } from '../../../Header/NavigationLogo';
import { LogoVariant } from '@benzinga/logos-ui';
import { FooterNavigationGroup, FooterLink } from '../../footerEntity';
import React, { type ReactNode } from 'react';
import styles from './SimpleFooter.module.scss';
import { AfterCopyrightBar } from '../../AfterCopyrightBar';

interface SimpleFooterProps {
  menu?: FooterNavigationGroup[];
  copyrightLinks?: FooterLink[];
  logoVariant?: LogoVariant;
  afterCopyrightBar?: ReactNode;
}

export const SimpleFooter: React.FC<SimpleFooterProps> = ({ afterCopyrightBar, copyrightLinks, logoVariant, menu }) => {
  const year = new Date().getFullYear();

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.mainBlock}>
        <hr className="border-slate-600 my-4" />
        <div>
          <NavigationLogo deviceType="mobile" logoVariant={logoVariant ?? 'default'} />
        </div>
        <div className={styles.footerNavigation}>
          {menu?.map(group => {
            return (
              <div className="footer-navigation-column" key={group.label}>
                <h4 className="footer-navigation-column-label text-white mb-4">{group.label}</h4>
                <ul>
                  {group?.items?.map(link => {
                    return (
                      <li className="mb-2" key={link.label}>
                        <a className="text-white font-light" href={link.url}>
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>

        <hr className="border-slate-600 my-4" />

        <div className="py-3 flex flex-wrap justify-between items-center">
          <div className="copyright-section text-left whitespace-nowrap text-gray-500 font-light text-sm mb-3">
            &copy; {year} Benzinga | All Rights Reserved
          </div>

          <ul className="flex flex-wrap mb-3">
            {copyrightLinks?.map(link => {
              return (
                <li className="footer-navigation-copyright-list-item" key={link.label}>
                  <a
                    className="font-light text-right text-sm text-gray-400 footer-navigation-copyright-link"
                    href={link.url}
                  >
                    {link.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <AfterCopyrightBar>{afterCopyrightBar}</AfterCopyrightBar>
      </div>
    </div>
  );
};

export default SimpleFooter;
